module.exports = __webpack_public_path__ + "static/media/bg.bb3dd9a8.png";